
import {defineComponent} from "@nuxtjs/composition-api";
import type {PropType} from "vue";
import type {
  GetVacationHomeData,
  HomeTempProductSection,
  // HomeTempProductItem,
  // HomeTempImageItem
} from "~/services/model/product";

import ModuleBox from "./components/ModuleBox.vue";
import ModuleHarbor from "./components/ModuleHarbor.vue";
import ModuleCompany from "./components/ModuleCompany.vue";
import ModuleHotRecommend from "./components/ModuleHotRecommend.vue";
import ProductCard from "./components/ProductCard.vue";
import ModuleTemp1 from './components/ModuleTemp1.vue'

import clsx from "clsx";

const MAP_LINE_COLORS = [
  "linear-gradient(90deg, #005EDC 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #F25B3B 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #1F9D8B 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #FFB200 0%, #FFFFFF 100%)",
  "linear-gradient(90deg, #F2007D 0%, #FFFFFF 100%)",
];

const getBoxColor = (index: number) => {
  return MAP_LINE_COLORS[index % MAP_LINE_COLORS.length];
};

const ModuleContentBanner = defineComponent({
  props: {
    url: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
  },
  render() {
    return (
      <div class="w-full">
        <a class="block h-[200px] main-width" href={this.url}>
          <img class="w-full h-full object-cover" src={this.path}></img>
        </a>
      </div>
    );
  },
});

const ImgCard = defineComponent({
  props: {
    url: String,
    src: String,
    height: Number,
  },
  render() {
    // this.height * this.default + 20 * (rowSpan - 1)
    return (
      <a
        class="block w-full h-full"
        href={this.url}
        style={{
          height: `${this.height}px`,
        }}
      >
        <el-image
          class="w-full h-full rounded"
          lazy
          fit="cover"
          src={this.src}
        />
      </a>
    );
  },
});

export default defineComponent({
  name: "OperationConfiguration",
  components: {
    ModuleBox,
    ModuleContentBanner,
    ModuleHarbor,
    ModuleCompany,
    ProductCard,
    ImgCard,
  },
  props: {
    modules: {
      type: Array as PropType<GetVacationHomeData["content"]>,
      default: () => [],
    },
  },

  render(h) {
    const {modules} = this;
    const renderModuleContent = (content: HomeTempProductSection) => {
      if(content.type === "1"){
        return h(ModuleTemp1, {
          props: {
            items: content.data
          }
        })
      }

      let rowHeight = 300;
      return (
        <div
          class={clsx("grid grid-cols-5 gap-x-4 gap-y-5", {
            "grid-rows-2": content.data.some((item) =>
              item.type === "image"
                ? false
                : item.row_span > 1 || item.col_span > 1
            ),
          })}
        >
          {content.data.map((item, index) => {
            let rowSpan = item.row_span || 1;
            let colSpan = item?.col_span || 1;

            if (content.type === "2") {
              rowHeight = 180;
              colSpan = item.type === "image" ? 1 : 2;
              rowSpan = item.type === "image" ? 2 : 1;
            }
            if (item.type === "image") {
              return (
                <div
                  key={index}
                  class={clsx({
                    // TODO: 不合理 图片的位置应该在第5个现在在最后所以需要指定位置
                    "col-start-5 row-start-1": ['2', '6'].includes(content.type),  //content.type === '6',
                    // "col-start-5 row-start-1": content.type === ,
                    "row-span-2": rowSpan === 2,
                  })}
                >
                  <ImgCard
                    url={item.url}
                    src={item.image}
                    height={rowHeight * rowSpan + 20 * (rowSpan - 1)}
                  />
                </div>
              );
            }
            // type = 1 时  layout 为 ''
            const layout =
              item.layout && item.layout !== "none"
                ? item.layout
                : content.type === "2"
                  ? "horizontal"
                  : "below";
            const imageHeight = layout === "above" ? rowHeight : 180;
            return (
              <div
                key={index}
                class={clsx({
                  "col-span-2": colSpan === 2,
                  "row-span-2": rowSpan === 2,
                })}
              >
                {h(ProductCard, {
                  props: {
                    imageHeight,
                    layout,
                    name: item.name,
                    image: item.image,
                    price: item.min_sale_price,
                    currencyLabel: item.currency_label,
                    levelPic: item.level_pic,
                    productType: item.product_type,
                    no: item.product_no,
                    isTripartiteProduct: item.is_tripartite_product,
                  },
                })}
              </div>
            );
          })}
        </div>
      );
    };
    const renderModule = (item: (typeof modules)[number], index: number) => {
      // 港口
      if (item.type === "4") {
        return h(ModuleHarbor, {
          props: {
            title: item.title,
            items: item.data,
          }
        });
      }
      // 公司
      if (item.type === "5") {
        return h(ModuleCompany, {
          props: {
            title: item.title,
            items: item.data,
          }
        });
      }
      if (item.type === "3") {
        return h(ModuleHotRecommend, {
          props: {
            title: item.title,
            items: item.data,
          }
        });
      }

      if (item.type === "9") {
        return h(ModuleContentBanner, {
          props: {
            url: item.data.url,
            path: item.data.path,
          }
        });
      }

      return h(ModuleBox, {
        props: {
          title: item.title,
          color: getBoxColor(index),
          url: item.url,
        },
      }, [renderModuleContent(item)]);
    };
    return (
      <div>
        {modules.map((item, index) => {
          return <div class="mt-10" key={ index }>{renderModule(item, index)}</div>;
        })}
      </div>
    );
  },
});
